import { render, staticRenderFns } from "./PointsIssuanceDialog.vue?vue&type=template&id=0179656a&scoped=true&"
import script from "./PointsIssuanceDialog.vue?vue&type=script&lang=js&"
export * from "./PointsIssuanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179656a",
  null
  
)

export default component.exports